<style lang="less" scoped>
    .viewer{

    }
    .ivu-modal-mask{
        z-index: 1030;
    }
    .viewer-wrap{
        text-align: center;
        padding: 40px 40px 10px 40px;
        overflow-x: auto;
        white-space: nowrap;
        z-index: 1030;
    }
    .viewer-item{
        position: relative;
        display: inline-block;
        vertical-align: top;
        width: 640px;
        /*min-width: 550px;*/
        height: 100%;
        background: white;
        border-radius: 10px;
        margin: 0 2px;
        overflow: hidden;
    }
    .viewer-item-bounce{
        -webkit-animation-name: bounce;
        animation-name: bounce;
        -webkit-transform-origin: center bottom;
        transform-origin: center bottom;
        -webkit-animation-duration: .8s;
        animation-duration: .8s;
    }
    .viewer-item-index-back{
        display: inline-block;
        position: absolute;
        left: -20px;
        top: -5px;
        width: 0;
        height: 0;
        border-bottom: 25px solid #464c5b;
        border-left: 30px solid transparent;
        border-right: 30px solid transparent;
        transform: rotate(-45deg);
        overflow: hidden;
        z-index: 2;
    }
    .viewer-item-index{
        display: inline-block;
        position: absolute;
        left: 0;
        top: 2px;
        width: 25px;
        height: 20px;
        line-height: 20px;
        /*color: white;*/
        z-index: 3;
        text-align: center;
    }
    .viewer-item-header{
        text-align: center;
        padding: 10px;
    }
    .viewer-item-content{
        position: absolute;
        top: 10px;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 10px;
        text-align: left;
        overflow: auto;
    }
    .ivu-modal-close{
        z-index: 1;
    }
    .indicator-wrap{
        position: fixed;
        top: 10px;
        left: 0;
        right: 0;
        text-align: center;
        z-index: 1100;
    }
    .indicator{
        position: relative;
        display: inline-block;
        vertical-align: top;
        margin: 0 3px;
        width: 20px;
        height: 20px;
        line-height: 20px;
        border-radius: 50%;
        border: 1px solid #000;
        background: white;
        box-sizing: border-box;
        font-weight: bold;
        cursor: pointer;
    }
    .indicator:hover{
        background: #e5e5e5;
    }
    .indicator-active{
        /*border-color: #2b8cf6;*/
        /*color: #2d8cf6;*/
    }
    .indicator-number{
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        line-height: 1;
    }
</style>
<template>
  <div class="viewer">
    <div v-show="is_show">
      <transition name="fade">
        <div
          v-if="is_show"
          class="ivu-modal-mask"
          :style="z_index_style"
        />
      </transition>
      <transition-group
        ref="viewerWrap"
        class="ivu-modal-wrap viewer-wrap"
        name="ease"
        tag="ul"
        :style="z_index_style"
        @click="hide"
      >
        <li
          v-for="(item, index) in items"
          ref="viewerItems"
          :key="item.item_id"
          class="viewer-item"
          :class="{'viewer-item-bounce': item.bounce, 'viewer-item-active': index === cur_index}"
        >
          <!--<div class="viewer-item-index-back"></div>-->
          <div class="viewer-item-index">
            {{ index+1 }}
          </div>
          <a
            class="ivu-modal-close"
            @click.stop="closeItem(index)"
          >
            <Icon type="ios-close" />
          </a>
          <div class="viewer-item-header" />
          <div class="viewer-item-content">
            <ItemContent
              :type="item.type"
              :model_id="item.model_id"
              :receipt_type="item.receipt_type"
              :viewer-params="item.viewerParams"
              :close="()=>closeItem(index)"
            />
          </div>
        </li>
      </transition-group>
      <ul
        class="indicator-wrap"
        :style="z_index_style"
      >
        <li
          v-for="(item, index) in items"
          :key="item.item_id"
          class="indicator"
          :class="{'indicator-active': index === cur_index}"
          @click.stop="setCurItem(index)"
        >
          <span class="indicator-number">{{ index + 1 }}</span>
        </li>
      </ul>
    </div>
    <Drawer
      ref="drawer"
      v-model="is_show_drawer"
      :width="70"
      draggable
      :mask="false"
      @on-resize-width="fireResize"
    >
      <ItemContent
        v-if="is_show_drawer"
        :type="drawer.type"
        :model_id="drawer.model_id"
      />
    </Drawer>
  </div>
</template>
<script>
  import Scroll from 'scroll';
  import ExpenseGroupViewer from './components/expense_group';
  import ContractViewer from './components/contract';
  import OutsourceContractViewer from './components/outsource_contract';
  import StockInOrderViewer from './components/stock_in_order';
  import Stock from './components/stock';
  import WikiViewer from './components/wiki';
  import InvoiceViewer from './components/invoice';
  import ItemContent from './content.js';
  export default {
    components: { ExpenseGroupViewer, ContractViewer, OutsourceContractViewer,
                  StockInOrderViewer, Stock, WikiViewer, InvoiceViewer, ItemContent },
    data() {
      return {
        id: 0,
        items: [],
        items_hash: {},
        new_item: {
          item_id: 0,
          type: '', //ExpenseGroup, Contract...
          model_id: 0,
          bounce: false,
          receipt_type: '',
        },
        cur_index: 0,
        max_z_index: 1000,
        is_show: false,
        drawer: {
          type: '',
          model_id: 0
        },
        is_show_drawer: false,
      }
    },
    computed: {
      cur_customer() {
        return this.$store.state.cur_customer;
      },
      z_index_style() {
        return {
          zIndex: this.max_z_index
        }
      }
    },
    watch:{
      items_hash(value) {
    
      }
    },
    created() {
      this.addEvents();
      window.Scroll = Scroll;
    },
    mounted() {
      //
    },
    methods: {
      addEvents() {
        window.eventHub.$on('viewer-show', this.addItem);
        window.eventHub.$on('drawer-show', this.showDrawer);
        window.eventHub.$on('customer-delegate', this.doDelegate);
      },
      doDelegate(delegatee_id, model_type, model_id) {
        this.$util.ajax.post(this.$util.ajax.api.add_model_delegate, {
          delegatee_id,
          model_id,
          model_type
        }).then(res => res.data).then(data => {
          if (data.code === 1) {
            this.$Message.success({
              content: '操作成功!'
            })
          } else {
            this.$Modal.error({
              title: '提示',
              content: data.msg
            })
          }
        }).catch(e => {
          console.log(e)
        })
      },
      addItem(model_id, type, receipt_type = '', viewerParams) {

        const hash_key = [model_id, type, receipt_type].reduce((s, i) => s + (i || ''), '')
        this.updateViewerZIndex();
        if (this.items_hash[hash_key]) {
          //this.$Message.warning('内容已经打开了');
          const len = this.items.length;
          for (let i = 0; i < len; i++) {
            const item = this.items[i];
            if (item.model_id === model_id && item.type === type && item.receipt_type === receipt_type) {
              this.$nextTick(() => {
                this.setCurItem(i);
              });
              this.bounceItem(item);
              return
            }
          }
        }
        const item = Util.clone(this.new_item);
        item.item_id = this.id++;
        item.type = type;
        item.model_id = model_id;
        item.receipt_type = receipt_type // 收款单组件会用
        item.viewerParams = viewerParams
        this.items.push(item);
        this.items_hash[hash_key] = item;
        this.show();
        this.$nextTick(() => {
          this.setCurItem(this.items.length - 1);
        });
      },
      show() {
        this.is_show = true;
      },
      hide() {
        this.is_show = false;
        this.items = [];
        this.items_hash = {};
      },
      closeItem(index) {
        const item = this.items[index];
        delete this.items_hash[`${item.type}${item.model_id}${item.receipt_type}`];
        this.items.splice(index, 1);
        if (this.items.length === 0) {
          this.hide();
        } else {
          this.cur_index--;
        }
      },
      setCurItem(index) {
        //let item = this.items[index];
        //this.bounceItem(item);
        const scrollLeft = this.$refs.viewerItems[index].offsetLeft - 670;
        Scroll.left(this.$refs.viewerWrap.$el, scrollLeft, {duration: 400});
      },
      bounceItem(item) {
        item.bounce = true;
        setTimeout(() => {
          item.bounce = false;
        }, 1000);
      },
      bodyClick() {
        //document.body.click();
      },
      showDrawer(model_id, type) {
        this.updateDrawerZIndex();
        this.drawer.type = type;
        this.drawer.model_id = model_id;
        this.is_show_drawer = true;
      },
      updateViewerZIndex() {
        this.max_z_index = this.$util.getMaxZIndex() + 1;
      },
      updateDrawerZIndex() {
        const max_z_index = this.$util.getMaxZIndex() + 1;
        try {
          this.$refs.drawer.$el.querySelector('.ivu-drawer-mask').style.zIndex = max_z_index;
          this.$refs.drawer.$el.querySelector('.ivu-drawer-wrap').style.zIndex = max_z_index;
        } catch (e) {
          console.warn(e);
        }
      },
      fireResize() {
        window.dispatchEvent(new Event('resize'));
      }
    }
  }
</script>
